// test2483
(2483 && 0);
